/** @file spaceEntries: the viewport empty-space menu (frame, camera, grid, joints, quads, key). */
import { keyFrame } from '../../panels/timeline/keyFrame';
import type { MenuEntry, SpaceMenuCtx } from './registryTypes';

const via = (id: string) => (c: SpaceMenuCtx): void => { c.handlers[id]?.(); };

/** Frame selection, Reset camera, Grid on/off, Joints on/off, Quads on/off, then Key whole pose (only in the editing viewport). */
export const SPACE_ENTRIES: MenuEntry<SpaceMenuCtx>[] = [
  { kind: 'item', id: 'camera.frame', label: () => 'Frame selection', chords: ['viewport.frameSelection'], run: via('viewport.frameSelection') },
  { kind: 'item', id: 'camera.reset', label: () => 'Reset camera', chords: ['viewport.camera.reset'], run: via('viewport.camera.reset') },
  {
    kind: 'item', id: 'camera.grid', label: (c) => (c.store.getState().camera.grid ? 'Hide grid' : 'Show grid'), chords: ['viewport.grid.toggle'],
    run: via('viewport.grid.toggle'),
  },
  {
    kind: 'item', id: 'camera.joints', label: (c) => (c.store.getState().camera.joints ? 'Hide joints' : 'Show joints'), chords: ['viewport.joints.toggle'],
    run: via('viewport.joints.toggle'),
  },
  {
    kind: 'item', id: 'camera.quads', label: (c) => (c.store.getState().camera.quads ? 'Hide quads' : 'Show quads'), chords: ['viewport.quads.toggle'],
    run: via('viewport.quads.toggle'),
  },
  { kind: 'separator' },
  {
    kind: 'item', id: 'key.pose', label: () => 'Key whole pose', chords: ['transport.keyAll'], disabled: (c) => !c.editing,
    run: (c) => { keyFrame(c.store, c.store.getState().playhead.frame); },
  },
];
